<template>
    <v-card>
        <v-card-title>{{ $t("PROGRAM.unregister_card.title") }}</v-card-title>
        <v-card-text>{{ $t("PROGRAM.unregister_card.body") }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="$emit('close')">
            {{ $t("PROGRAM.unregister_card.cancel") }}</v-btn
          >
          <v-btn color="primary" @click="$emit('confirmUnfavorite', event)">{{ $t("PROGRAM.unregister_card.save") }}</v-btn>
        </v-card-actions>
      </v-card>
</template>

<script>
export default {
    props: ['event']
}
</script>